import { MouseEvent, ReactElement, useEffect, useState } from 'react';
import styled from 'styled-components';

import { ColorType } from '../api';
import { Popover } from '../atoms';
import { ColorDisc } from '../pages/oneProject/components/Table/ColorChanger';

type Props = {
  className?: string;
  children: ReactElement;
  isHidePopover?: boolean;
  offsetY?: number;
  offsetX?: number;
  isDisabled?: boolean;
  color: ColorType;
};

function ColorActionButton({
  className,
  children,
  isHidePopover,
  offsetY,
  offsetX,
  isDisabled,
  color,
}: Props) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  useEffect(() => {
    isHidePopover && setAnchorEl(null);
  }, [isHidePopover]);

  const handleActionsOpen = (event: MouseEvent<HTMLElement>) => {
    if (isDisabled) return;

    setAnchorEl(event.currentTarget);
  };

  const onOverlayClick = (event: MouseEvent<HTMLElement>) => {
    if (event.currentTarget !== event.target) {
      return;
    }
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        isDisabled={isDisabled}
        className={className}
        onClick={handleActionsOpen}
      >
        <ColorDisc color={color ?? 'red'} />
      </Button>
      <Popover
        onOverlayClick={onOverlayClick}
        refElem={anchorEl}
        offsetY={offsetY}
        offsetX={offsetX}
      >
        {children}
      </Popover>
    </>
  );
}

const Button = styled.div<{ isDisabled?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 20px;
  cursor: ${props => (props.isDisabled ? 'not-allowed' : 'pointer')};
`;

export default ColorActionButton;
